// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarOutlinedSvg from "@fishx/icons-svg/es/asn/CarOutlined";
import FishxIcon from '../components/FishxIcon';

var CarOutlined = function CarOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarOutlinedSvg
  }));
};

CarOutlined.displayName = 'CarOutlined';
export default React.forwardRef(CarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CarOutlined.js
// module id = 2164
// module chunks = 0